module.exports = __webpack_public_path__ + "static/icon003310d1371f87f4644d91f9d994a296ac28.png";